module.exports = __webpack_public_path__ + "static/media/profile-pie.7cde8cb8.png";